import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {observer} from 'mobx-react';
import styles from "./game-scoreboard.module.scss";
import classNames from "classnames";
import {GameScoreboardCell} from "./game.scoreboard.cell";
import {GameCardScoreboardViewModel} from "../game-card/view-models/game-card.scoreboard.view-model";
import type {GameCardViewModel} from "../game-card/view-models/game-card.view-model";

export class GameScoreboardProps extends BaseProps {
  game: GameCardViewModel;
  shouldRenderFullScoreboard: boolean;
}

export const GameScoreboard = observer(({game, shouldRenderFullScoreboard}: GameScoreboardProps) => {

  const scoreboardStages = game.scoreboard;
  return (
      <div className={classNames(styles.container)}>
        {scoreboardStages?.map((stage: GameCardScoreboardViewModel, index) => (
            <div className={classNames(styles.score_column)} key={index}>
              {shouldRenderFullScoreboard ? <span
                  className={classNames(styles.cell, styles.score_column_title, {[styles.main]: stage.isMain})}>{stage.columnTitle}</span> : null}
              {stage?.scores?.map((score, index) => (
                <GameScoreboardCell key={index} stage={stage} index={index}/>
              ))}
            </div>
        ))}
      </div>
  )
});
